import { mountComponent } from '@/utils';
import { LoadingContainer } from '@/components/shared';
import { Recreation } from '@/types';
import React, { useEffect, useState } from 'react';
import { RecreationItem } from './recreationItem';
import { useRecreations } from '../../hooks';

const RecreationShow: React.FC = () => {
  const [recreation, setRecreation] = useState<Recreation>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { fetchRecreation } = useRecreations();
  const id = window.location.pathname.split('/')[3];

  useEffect(() => {
    (async () => {
      if (!id) return;
      try {
        const recreationResponse = await fetchRecreation(id);
        setRecreation({ ...recreationResponse });
        setIsLoading(false);
      } catch (e) {
        console.warn('error is', e);
      }
    })();
  }, [fetchRecreation, id]);

  if (isLoading) {
    return <LoadingContainer />;
  }
  if (!recreation) {
    return <></>;
  }

  return (
    <>
      <div className='pt-3 w-100'>
        <div className='text-center'>
          <h3 className='text-black fw-bold'>{recreation.title}</h3>
        </div>
      </div>
      <div className='body bg-white p-3 mb-3'>
        {/* 修正リンクに変更する */}
        <RecreationItem
          title='レクの基本情報'
          url={`/partners/recreations/${id}/edit?formKind=title`}
        />
        <RecreationItem
          title='金額・その他の情報'
          url={`/partners/recreations/${id}/edit?formKind=price`}
        />
        <RecreationItem
          title='レクに表示するプロフィール'
          url={`/partners/recreations/${id}/edit?formKind=profile`}
        />
        <RecreationItem
          title='レク画像・関連ファイルを追加'
          url={`/partners/recreations/${id}/edit?formKind=file`}
        />
        <RecreationItem
          title='このレクの口コミ一覧'
          url={`/partners/recreations/${id}/evaluations`}
        />
      </div>
    </>
  );
};

mountComponent('#recreationShow', () => <RecreationShow />);
